import { jsx } from "react/jsx-runtime";
import { Search as Search$1 } from "@wix/wix-ui-icons-common/on-stage";
import { TextField } from "@wix/wix-ui-tpa/cssVars";
import { useCallback } from "react";
import { useConfig } from "../../../../contexts/config-context.js";
import { useTranslation } from "../../../../contexts/translation-context.js";
import { st, classes } from "./search.st.css";
const Search = ({ autoFocus, className, ...props }) => {
  const { t } = useTranslation();
  const { isRTL: rtl } = useConfig();
  const handleRef = useCallback(
    (input) => {
      if (!autoFocus || !input) {
        return;
      }
      setTimeout(() => {
        input.focus();
      });
    },
    [autoFocus]
  );
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...props,
      inputRef: handleRef,
      "data-hook": "country-search",
      className: st(classes.root, { rtl }, className),
      prefix: /* @__PURE__ */ jsx(Search$1, {}),
      placeholder: t("field.phone.country-search-input.placeholder"),
      "aria-label": t("field.phone.country-search-input.aria-label"),
      autoComplete: "off"
    }
  );
};
export {
  Search
};
//# sourceMappingURL=search.js.map
